import React from 'react';
import { Routes, Route } from 'react-router-dom';
import CatalogPage from './CatalogPage';
import CatalogItemEditPage from './CatalogItemEditPage';

/** Pages under /casa/catalogo. */
const CatalogRoutes: React.FC = () => (
  <Routes>
    <Route index element={<CatalogPage />} />
    <Route path="novo" element={<CatalogItemEditPage />} />
    <Route path=":id" element={<CatalogItemEditPage />} />
  </Routes>
);

export default CatalogRoutes;
